import { render, staticRenderFns } from "./DnsZones.vue?vue&type=template&id=cdbab096"
import script from "./DnsZones.vue?vue&type=script&lang=js"
export * from "./DnsZones.vue?vue&type=script&lang=js"
import style0 from "./DnsZones.vue?vue&type=style&index=0&id=cdbab096&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports